import { render, staticRenderFns } from "./productList.vue?vue&type=template&id=3dc11ec4&scoped=true"
import script from "./productList.vue?vue&type=script&lang=js"
export * from "./productList.vue?vue&type=script&lang=js"
import style0 from "./productList.vue?vue&type=style&index=0&id=3dc11ec4&lang=less"
import style1 from "./productList.vue?vue&type=style&index=1&id=3dc11ec4&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc11ec4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dc11ec4')) {
      api.createRecord('3dc11ec4', component.options)
    } else {
      api.reload('3dc11ec4', component.options)
    }
    module.hot.accept("./productList.vue?vue&type=template&id=3dc11ec4&scoped=true", function () {
      api.rerender('3dc11ec4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/productmanager/productList/productList.vue"
export default component.exports